import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { DoneGamesListAndDetail } from "./DoneGamesListAndDetail";
import { PitchingGamesListAndDetail } from "./PitchingGamesListAndDetail";
import { GamesLifecycleListAndDetail } from "./GamesLifecycleListAndDetail";

export const GamesListAndDetail = () => {
  const [searchParams] = useSearchParams();
  const [isDone, setIsDone] = useState(false);
  const [isPitching, setIsPitching] = useState(false);

  useEffect(() => {
    const selectedFilter = searchParams.get("games")?.toLocaleUpperCase() || "";
    setIsDone(selectedFilter === "DONE");
    setIsPitching(selectedFilter === "PITCHING");
  }, [searchParams]);

  if (isDone) {
    return <DoneGamesListAndDetail />;
  }

  if (isPitching) {
    return <PitchingGamesListAndDetail />;
  }

  return <GamesLifecycleListAndDetail />;
};
